import { render } from "./DisplayResidualFee.vue?vue&type=template&id=726ff3ec&scoped=true"
import script from "./DisplayResidualFee.vue?vue&type=script&lang=js"
export * from "./DisplayResidualFee.vue?vue&type=script&lang=js"

import "./DisplayResidualFee.vue?vue&type=style&index=0&id=726ff3ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726ff3ec"]])

export default __exports__